/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_YesterdayInputs */

const en_ui_filter_yesterday = /** @type {(inputs: Ui_Filter_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yesterday`)
};

const de_ui_filter_yesterday = /** @type {(inputs: Ui_Filter_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gestern`)
};

/**
* | output |
* | --- |
* | "yesterday" |
*
* @param {Ui_Filter_YesterdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_yesterday = /** @type {((inputs?: Ui_Filter_YesterdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_YesterdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_yesterday(inputs)
	return de_ui_filter_yesterday(inputs)
});